var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('sidebar'),_c('div',{staticClass:"app-content"},[_c('navbar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),(_vm.isOnboardingNeeded)?_c('user-onboarding',{ref:"userOnboarding"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }